module.exports = __webpack_public_path__ + "img/CCS_BAK.31b69a4f.png";